import React from 'react';
import Sidebar from './Sidebar';
import './Layout.css';

function Layout({ user, onLogout, children, pageTitle, pageSubtitle, darkMode = true, onToggleDarkMode, subscriptionTier, hideSidebar = false }) {
  // Check for demo mode - prefer runtime flag but fall back to build-time env
  const isDemo = Boolean(
    (typeof window !== 'undefined' && window.__DEMO_MODE__) ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEMO_MODE === 'true')
  );
  const demoMessage =
    (typeof window !== 'undefined' && window.__DEMO_TOOLTIP__) ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEMO_TOOLTIP) ||
    'Live demo is read-only. Bookings, payments and uploads are disabled.';
  
  // Debug: log demo mode status
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log('[Demo Banner] isDemo:', isDemo, 'window.__DEMO_MODE__:', window.__DEMO_MODE__);
    }
  }, [isDemo]);

  return (
    <div className={`app-layout ${darkMode ? 'dark-mode' : 'light-mode'} ${hideSidebar ? 'embedded-no-sidebar' : ''}`}>
      {!hideSidebar && (
        <Sidebar user={user} onLogout={onLogout} darkMode={darkMode} onToggleDarkMode={onToggleDarkMode} subscriptionTier={subscriptionTier} />
      )}
      
      <main className="main-content">
        {/* Background Effects */}
        <div className="bg-effects">
          <div className="bg-gradient-1"></div>
          <div className="bg-gradient-2"></div>
          <div className="bg-grid"></div>
        </div>

        {isDemo && (
          <div className="demo-banner">
            <strong>Live Demo</strong>
            <span>{demoMessage}</span>
          </div>
        )}

        {/* Page Header */}
        {(pageTitle || pageSubtitle) && (
          <header className="page-header">
            <div className="page-header-content">
              {pageTitle && <h1 className="page-title">{pageTitle}</h1>}
              {pageSubtitle && <p className="page-subtitle">{pageSubtitle}</p>}
            </div>
            <div className="header-decorations">
              <div className="decoration-circle"></div>
              <div className="decoration-circle delay-1"></div>
              <div className="decoration-circle delay-2"></div>
            </div>
          </header>
        )}

        {/* Page Content */}
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
}

export default Layout;

